import { Button } from "antd";
import styled from "styled-components";

export const ContentInfo = styled.div`
  display: flex;
  align-items: center;

  .image-container-render-certificate {
    position: relative;
    max-width: 40px;
    max-height: 40px;
  }

  p {
    color: ${({ theme }) => theme.mode === "dark" && "#FFFFFF"};
    margin: 0;
    padding: 0 1rem;
  }

  img {
    height: 2.5rem;
    margin-right: 0.7rem;
  }
`;

export const ContainerCertificate = styled.div`
  display: none;
`;

export const ButtonAnt = styled(Button)`
  margin: 1.2rem 0 0 0;
  height: 48px;

  font-size: 1.125rem;

  span {
    color: ${({ theme }) => theme.colors.textMasterColor} !important;
  }
`;

export const RenderCertificateContainer = styled.div`
  margin: 2rem 2rem 0 0;

  @media (max-width: 800px) {
    width: 100%;
    margin: 2rem 0;
  }
`;
